import React from "react";

const Pagination = ({ pageTrack, pagination, onPageChange, onLimitChange }) => {
  const totalPages = pageTrack.totalPages || 1;

  const pageOptions = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleLimitChange = (event) => {
    const newLimit = Number(event.target.value);
    if (onLimitChange) {
      onLimitChange(newLimit);
    }
  };

  const handleJumpChange = (event) => {
    const newPage = Number(event.target.value);
    if (newPage !== pagination.page) {
      onPageChange(newPage);
    }
  };

  const goToPreviousPage = () => {
    if (pagination.page > 1) {
      onPageChange(pagination.page - 1);
    }
  };

  const goToNextPage = () => {
    if (pagination.page < totalPages) {
      onPageChange(pagination.page + 1);
    }
  };

  return (
    <div className="d_flex text_wrap_nowrap align_center justify_end w_fit ml_auto py_4">
      <p>Records per page: &nbsp;</p>
      <select className="builder_input mr_1" value={pagination.limit} onChange={handleLimitChange}>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="300">300</option>
        <option value="400">400</option>
      </select>
      <span
        className={`chevron border_radius_medium material-symbols-outlined mr_1 ${pagination.page === 1 ? "chevron_disabled" : ""}`}
        onClick={pagination.page > 1 ? goToPreviousPage : undefined}
        style={{ cursor: pagination.page > 1 ? "pointer" : "default" }}
      >
        chevron_left
      </span>

      <div className="d_flex align_center mx_1">
        <select
          className="builder_input"
          value={pagination.page}
          onChange={handleJumpChange}
          style={{ minWidth: "60px" }}
        >
          {pageOptions.map((pageNum) => (
            <option key={pageNum} value={pageNum}>
              {pageNum}
            </option>
          ))}
        </select>
      </div>

      <span className="mr_1">
        Page {pageTrack.currPage || 1} of {totalPages}
      </span>

      <span
        className={`chevron border_radius_medium material-symbols-outlined mr_1 ${pagination.page === totalPages ? "chevron_disabled" : ""}`}
        onClick={pagination.page < totalPages ? goToNextPage : undefined}
        style={{ cursor: pagination.page < totalPages ? "pointer" : "default" }}
      >
        chevron_right
      </span>
    </div>
  );
};

export default Pagination;
